/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import cx from 'classnames';
import { getCurrencyCode, getMinimumFractionDigits } from 'utils/helpers';

const propTypes = {
  amount: PropTypes.number.isRequired,
  highlightAmount: PropTypes.bool,
};

const LateFeeAU = ({ amount, highlightAmount }) => {
  const amountClasses = cx({
    'invoice-item__amount': true,
    'invoice-item__amount--warning': highlightAmount,
  });

  return (
    <div className="invoice-item">
      <span className="invoice-item__desc">
        <span className="invoice-item__deadline invoice-item__deadline--warning">
          <FormattedMessage id="selfservice.invoices.lateFee" />
        </span>
      </span>
      <span className={amountClasses}>
        <FormattedNumber
          style="currency"
          currency={getCurrencyCode()}
          minimumFractionDigits={getMinimumFractionDigits(amount, 2)}
          value={amount}
        />
      </span>
    </div>
  );
};

LateFeeAU.propTypes = propTypes;

export default LateFeeAU;
